"use client";
import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import "./PaymentSection.css";
import {
  faCircleExclamation,
  faHandHoldingDollar,
  faHandshake,
  faPlus,
  faWallet,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Login_Modal from "../../common-components/common_modal/login_modal/Login_Modal";
import { getAllWalletHistory } from "../../../features/wallet/walletSlice";
import { useDispatch, useSelector } from "react-redux";

function PaymentSection({ register, watch, setValue, errors }) {
  const [paymentMethod, setPaymentMethod] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const shopImageRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImagePreview(URL.createObjectURL(file));
    } else {
      setImagePreview(null);
    }
  };

  const onSubmit = (data) => {
    console.log(data);
  };

  const removeImage = () => {
    setImagePreview(null);
    setValue("report", null);

    if (shopImageRef.current) {
      shopImageRef.current.value = "";
    }
  };
  const dispatch = useDispatch();
  const allWalletHistory = useSelector(
    (state) => state.wallet.allWalletHistory,
  );

  useEffect(() => {
    dispatch(getAllWalletHistory());
  }, [dispatch]);

  return (
    <section className="payment-section">
      <div className="payment-card">
        <h5 className="payment-title">Payment</h5>

        {/* UPI Section */}
        {/* <div className="payment-box">
          <div>
            <p className="section-sub">
              <b>Pay with UPI</b>
            </p>
            <p className="section-sub">Pay by any UPI App</p>
          </div>

          <div>
            <Form.Check
              type="radio"
              value="2"
              className={errors?.payment_method ? "is-invalid" : ""}
              {...register("payment_method", {
                required: "Please select a payment method",
              })}
            />
          </div>
        </div> */}

        <label htmlFor="upi-payment" className="payment-box">
          <div>
            <p className="section-sub">
              <b>Pay with UPI</b>
            </p>
            <p className="section-sub">Pay by any UPI App</p>
          </div>

          <div>
            <Form.Check
              id="upi-payment"
              type="radio"
              value="2"
              className={errors?.payment_method ? "is-invalid" : ""}
              {...register("payment_method", {
                required: "Please select a payment method",
              })}
            />
          </div>
        </label>

        {/* <div className="payment-box">
          <div>
            <p className="section-sub">
              <b>Pay with Wallet</b>
            </p>
            <p className="section-sub">
              {" "}
              <div className="plus-b">
                <FontAwesomeIcon icon={faWallet} />
              </div>{" "}
              Balance : ₹{" "}
              {parseFloat(allWalletHistory?.user_wallet?.amount || 0).toFixed(
                2,
              )}
            </p>
          </div>
          <div>
            <Form.Check
              type="radio"
              value="3"
              className={errors?.payment_method ? "is-invalid" : ""}
              {...register("payment_method")}
            />
          </div>
        </div> */}

        <label htmlFor="wallet-payment" className="payment-box">
          <div>
            <p className="section-sub">
              <b>Pay with Wallet</b>
            </p>

            <p className="section-sub">
              <span className="plus-b">
                <FontAwesomeIcon icon={faWallet} />
              </span>{" "}
              Balance : ₹{" "}
              {parseFloat(allWalletHistory?.user_wallet?.amount || 0).toFixed(
                2,
              )}
            </p>
          </div>

          <div>
            <Form.Check
              id="wallet-payment"
              type="radio"
              value="3"
              className={errors?.payment_method ? "is-invalid" : ""}
              {...register("payment_method")}
            />
          </div>
        </label>
        <div className="gray_input_group  mb-3">
          {" "}
          {errors?.payment_method && (
            <div className="payment-error">
              <FontAwesomeIcon
                icon={faCircleExclamation}
                className="payment-error-icon"
              />
              <span>{errors.payment_method.message}</span>
            </div>
          )}
        </div>

        {/* <div className="payment-box">
          <div>
            <p className="section-sub ">
              <b>Add Report</b>{" "}
            </p>

            <Form.Group className="gray_input_group input_group mt-3">
              <Form.Control
                type="file"
                accept="image/*"
                className={errors?.report ? "is-invalid" : ""}
                {...register("report", {
                  onChange: (e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setImagePreview(URL.createObjectURL(file));
                    } else {
                      setImagePreview(null);
                    }
                  },
                })}
                ref={(e) => {
                  register("report").ref(e);
                  shopImageRef.current = e;
                }}
              />

              {imagePreview && (
                <div className="mt-3 preview_div">
                  <img
                    src={imagePreview}
                    alt="Shop Preview"
                    className="preview"
                  />
                  <FontAwesomeIcon
                    icon={faXmark}
                    className="x_mark"
                    onClick={removeImage}
                  />
                </div>
              )}
            </Form.Group>
          </div>
        </div> */}

        {/* COD */}
        {/* <div className="payment-box d-flex justify-content-between align-items-center">
          <div>
            <p className="section-title">Pay on Delivery</p>
            <p className="section-sub">
              {" "}
              <div className="plus-b">
                <FontAwesomeIcon icon={faHandHoldingDollar} />
              </div>{" "}
              Pay on Delivery (Cash / UPI)
            </p>
          </div>

          <Form.Check
            className="check-paymt"
            type="radio"
            name="payment"
            onChange={() => setPaymentMethod("cod")}
          />
        </div> */}

        {/* Cards */}
        {/* <div className="payment-box">
          <p className="section-title">
            Credit & Debit Cards <span>(Save & Pay via Cards)</span>
          </p>

          <div className="section-sub red">
            <div className="plus-b">
              <FontAwesomeIcon icon={faPlus} />
            </div>{" "}
            Add New Card
          </div>
        </div> */}

        {/* Wallet */}
        {/* <div className="payment-box d-flex justify-content-between align-items-center">
          <div>
            <p className="section-title">Wallet</p>
            <p className="section-sub">
              {" "}
              <div className="plus-b">
                <FontAwesomeIcon icon={faWallet} />
              </div>{" "}
              Balance : ₹ 0
            </p>
          </div>

          <button className="add-btn">Add</button>
        </div> */}
      </div>
    </section>
  );
}

export default PaymentSection;
